import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        onResetForm()
        handleClickShowForm(false)

    }

    const handleClickFetchAllStampLogs = async () => {

        const { fetchAllStampLogs } = FetchData
        const { executeFetch } = fetchAllStampLogs

        executeFetch()

    }

    const handleClickFetchSpecificStampLog = async (idstamplogs) => {
        
        const { FormScreen: {onResetForm} } = Forms

        const { fetchSpecificStampLog } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificStampLog

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idstamplogs: idstamplogs})
        executeFetch()

        handleClickShowForm(true)

    }
    
    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { FormScreen } = Forms
        const { formState, onResetForm } = FormScreen

        const _dataBody = {
            idstamplogs: formState.idstamplogs,
            idstamp: formState.idstamp,
            date_transaction: formState.date_transaction,
            type_transaction: formState.type_transaction,
            quantity: formState.quantity,
            observations: formState.observations,
            user: user.username
        }

        // console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)
        await marvarApi.post( `/legal-notarial/create-stamp-log`, _dataBody )
            .then(({ data }) => {
                
                alertMessage(data)
                onResetForm()
                handleClickFetchAllStampLogs()
                handleClickHideForm()

            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
        
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllStampLogs,
        handleClickFetchSpecificStampLog,
        onSubmitForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}